import { render, staticRenderFns } from "./PublicEventRegistration.vue?vue&type=template&id=3660596a&scoped=true&"
import script from "./PublicEventRegistration.vue?vue&type=script&lang=js&"
export * from "./PublicEventRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PublicEventRegistration.vue?vue&type=style&index=0&id=3660596a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660596a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDivider,VRow,VSkeletonLoader})
